"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactI18next = require("react-i18next");
var _reactRedux = require("react-redux");
var _get = _interopRequireDefault(require("lodash/get"));
var _RecentActivityTableComponent = _interopRequireDefault(require("./RecentActivityTableComponent"));
var _recentActivityHelper = require("../../../helpers/recentActivityHelper");
var _recentActivitySelector = require("../../../redux/selectors/recentActivitySelector");
var _orderHistoryActions = require("../../../redux/actions/orderHistoryActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var data = (0, _recentActivitySelector.newRecentActivitySelector)(state);
  var columns = (0, _recentActivityHelper.getColumns)(ownProps.width, ownProps.themeModifier, ownProps.t);
  return {
    data: data,
    columns: columns,
    selectedAccountId: (0, _get["default"])(state, 'user.selectedAccountId', 0),
    OMSId: (0, _get["default"])(state, 'user.userInfo.OMSId', 1),
    recentActivityStartIndex: state.apexCore.orderHistory.recentActivityStartIndex
  };
};
var _default = exports["default"] = (0, _reactI18next.withTranslation)('activity')((0, _reactRedux.connect)(mapStateToProps, {
  getRecentActivity: _orderHistoryActions.getRecentActivity
})(_RecentActivityTableComponent["default"]));